import { render, staticRenderFns } from "./Plan1.vue?vue&type=template&id=6bb96f81&scoped=true&"
import script from "./Plan1.vue?vue&type=script&lang=js&"
export * from "./Plan1.vue?vue&type=script&lang=js&"
import style0 from "./Plan1.vue?vue&type=style&index=0&id=6bb96f81&prod&lang=scss&"
import style1 from "./Plan1.vue?vue&type=style&index=1&id=6bb96f81&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb96f81",
  null
  
)

export default component.exports